import { CardBackgroundViewModel } from '../../card-background-view-model';
import { Injectable } from '@angular/core';
import { combineLatest, Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { TheWoodsCardData } from '../../../../../../../models/print-cards/the-woods-card-data';
import { CardStack } from '../../../../../../../models/menu/section/card-stacks/card-stack';

@Injectable()
export class TheWoodsPostCardBackgroundViewModel extends CardBackgroundViewModel {
  override readonly cardData$: Observable<TheWoodsCardData>; // only override the type for the type system

  /**
   * Note, if there is a bleed border, then this accounts for it, and will make sure that the color strip is always
   * the same width within the card content area.
   */
  public readonly colorStripWidth$ = combineLatest([this.cardData$, this.cardStack$]).pipe(
    map(([cardData, cardStack]) => {
      const bleed = (cardStack?.nonPerforatedBleedBorderInInches() ?? 0) * CardStack.PIXELS_PER_INCH;
      const additionalHeight = cardStack?.isOnRegularPaper() ? bleed : 0;
      const colorStripWidth = cardData?.colorStripWidth();
      return `calc(${colorStripWidth} + ${additionalHeight}px)`;
    })
  );

  public readonly strainTypeColor$ = this.cardData$.pipe(map(cardData => cardData?.getStrainTypeColor()));
}
